import EventEmitter from 'eventemitter3';

function componentLoader(loadingState, fn) {
  return () => {
    // (Vuex) Loading begins now
    loadingState[0] = true;

    // (Vuex) Call when loading is done
    const done = () => {
      loadingState[0] = false;
    }

    const promise = fn();

    promise.then(done, done);

    return promise;

  };
}

export default function (in_fn) {
  // we put the boolean in a list to make the state reactive
  // to the using component
  const componentLoadingState = [true];
  const fn = componentLoader(componentLoadingState, in_fn);
  return {
    componentLoadingState,
    fn
  }
}
